import React from 'react'

import { useParams, Link } from 'react-router-dom'

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import Page from '../components/Page';


const myRepos = [
  { repoName: 'plasmatech8/extra-cool', repoId: 123, avatarUrl: 'https://avatars2.githubusercontent.com/u/40431112?s=60&v=4' },
  { repoName: 'plasmatech8/true-plasma', repoId: 213, avatarUrl: 'https://avatars2.githubusercontent.com/u/40431112?s=60&v=4' },
]
const contributedRepos = [
  { repoName: 'blazar/some-stuff', repoId: 1234312, avatarUrl: 'https://avatars2.githubusercontent.com/u/74807665?s=64&v=4' },
  { repoName: 'Mr360/awesome-algorithms', repoId: 1234312, avatarUrl: 'https://avatars2.githubusercontent.com/u/74807665?s=64&v=4' },
  { repoName: 'DrStrangle/Dormammu', repoId: 1234312, avatarUrl: 'https://avatars2.githubusercontent.com/u/74807665?s=64&v=4' },
]

function User() {

  const { userName } = useParams()
  const currentUser = "plasmatech8"
  const currentUserAvatar = 'https://avatars2.githubusercontent.com/u/40431112?s=60&v=4'

  return (
    <Page title={`${userName} - GitShares`}>

      <Container>
        <Box padding={5}>

          <Paper>
            <Box padding={3}>

              <Grid container spacing={3} >
                <Grid item xs={5} align="right">
                  <Avatar display="inline">
                    <img src={currentUserAvatar} alt="avatar for user"></img>
                  </Avatar>
                </Grid>
                <Grid item xs={5} align="left">
                  <Typography variant="h4">{userName}</Typography>
                </Grid>
                <Grid item xs={2} align="left">
                  {
                    userName === currentUser ? (
                      <Button variant="contained" color="primary">LOG-OUT</Button>
                    ) : (<br />)
                  }
                </Grid>
                <Grid item xs={12}>


                </Grid>

              </Grid>
            </Box>
            <br />

          </Paper>
          <br />

          {/* Owned repositories */}
          <Paper>
            <Box padding={3}>
              <Typography variant="h5">Owned Repositories:</Typography>
              <List>
                {
                  myRepos.map(repo => (
                    <ListItem button component={Link} to={`/${repo.repoName}`}>
                      <ListItemAvatar>
                        <Avatar>
                          <img src={repo.avatarUrl} alt="avatar for repository"></img>
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText>
                        <b>{repo.repoName}</b>
                      </ListItemText>
                    </ListItem>
                  ))
                }

              </List>
            </Box>
          </Paper>
          <br />

          {/* Contributed repositories */}
          <Paper>
            <Box padding={3}>
              <Typography variant="h5">Contributed Repositories:</Typography>
              <List>
                {
                  contributedRepos.map(repo => (
                    <ListItem button component={Link} to={`/${repo.repoName}`}>
                      <ListItemAvatar>
                        <Avatar>
                          <img src={repo.avatarUrl} alt="avatar for repository"></img>
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText>
                        <b>{repo.repoName}</b>
                      </ListItemText>
                    </ListItem>
                  ))
                }

              </List>
            </Box>
          </Paper>
        </Box>
      </Container >
    </Page>
  )
}

export default User
